import React from 'react';
import Box from './Box';
import { useTranslation } from 'react-i18next';

export default function Steps() {
    const { t } = useTranslation();
    return (
        <div className={'margin-home my-8'}>
            <div className={'bg-gray-50 px-10 py-8'}>
                <h2 className={' mb-2 text-center font-medium'}>
                    {t('translation:MAIN_PAGE.STEPS.TITLE')}
                </h2>
                <Box
                    classMame={'my-2'}
                    numer={1}
                    title={t('translation:MAIN_PAGE.STEPS.1.TITLE')}
                    content={t('translation:MAIN_PAGE.STEPS.1.CONTENT')}
                />
                <Box
                    classMame={'my-2'}
                    numer={2}
                    title={t('translation:MAIN_PAGE.STEPS.2.TITLE')}
                    content={t('translation:MAIN_PAGE.STEPS.2.CONTENT')}
                />
                <Box
                    classMame={'my-2'}
                    numer={3}
                    title={t('translation:MAIN_PAGE.STEPS.3.TITLE')}
                    content={t('translation:MAIN_PAGE.STEPS.3.CONTENT')}
                />
            </div>
        </div>
    );
}
